import { Col, Row } from "antd";
import { Form } from "views/components/common/Form";
import Styled from "styled-components";

const FooterModalWrapper = Styled.div`
	display: flex;
	flex-direction:column;
	align-items:center;
	width: 300px;
	text-align: "center";
	.noregistry__ticket-label{
		cursor: pointer;
		font-weight:700;
		text-decoration: underline;
		color:#145AB4
		
	}`;

const ButtonWrapper = Styled.div`
	display: flex;
	justify-content:center;
	width:100%;

	& button {
		width:60%;
	}

`;

const SocialMediaWrapper = Styled.div`
	width:100%;
	text-align:center;
`;

const StyledForm = Styled(Form)`
	text-align: left;
`;

const TextCol = Styled(Col)`
	display: flex;
	flex-direction:column;
	text-align: center;
	margin-bottom: 32px;
	.title__login-modal {
		font-weight: 800;
		font-size:16px;
		color:#145AB4
	}
`;

const Wrapper = Styled(Row)`
	display: flex;
	justify-content: space-around;
	align-items: center;
	justify-content: center;
	.error__label-temporary {
		color: #f5222d;
	}

	.pass__recover {
		text-align: right;
		& a {
			font-size:14px;
			font-weight:400;
			text-decoration: underline;
			color: #505050
		}
	}
	
	
	.modal__text-welcome_alert {
		font-weight: 700;
		color: #145AB4
	}

	.button__container {
		width: 60%;
	}
	.form__login-modal {
		width:100%;
	}

	.modal__text-welcome {
		font-size: 14px;
		font-weight: 600;
		color: #505050
	}
	.modal__registry-container {
		padding-bottom:10px;
		border-bottom: 1px solid #D4D4D4;
		& span > a {
			font-weight:700;
			color:#145AB4
		}
		
	}
	@media (min-width: 780px) {
		.modal__text-welcome {
		width:400px;
	}
		.form__login-modal {
		width:70%;
	}
  }

`;

export {
	Wrapper,
	TextCol,
	StyledForm,
	SocialMediaWrapper,
	ButtonWrapper,
	FooterModalWrapper,
};
